import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const HeartIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                d="M3.505 3.55C.608 6.025.168 10.206 2.475 13.174c1.264 1.626 4.234 4.458 7.627 7.486l.707.63c.359.317.46.394.755.482.28.083.58.083.858 0 .295-.088.396-.165.755-.483a179.69 179.69 0 0 0 4.123-3.76l.658-.627c1.649-1.58 2.87-2.848 3.554-3.728 2.32-2.986 1.894-7.193-1.041-9.633l-.199-.16c-2.534-1.96-5.793-1.762-8.156.227l-.123.107-.126-.11c-2.439-2.049-5.84-2.21-8.362-.055zm7.728 2.236a1 1 0 0 0 1.52 0c1.744-2.039 4.422-2.383 6.44-.707 2.1 1.746 2.402 4.728.74 6.868-.607.78-1.778 1.996-3.356 3.508l-.653.621-.677.635c-.682.635-1.377 1.271-2.058 1.886l-1.196 1.069-1.177-1.051c-3.03-2.727-5.677-5.272-6.762-6.668-1.65-2.122-1.337-5.093.75-6.877 1.968-1.681 4.681-1.328 6.43.716z"
            />
        </svg>
    );
};
